import gsap from "gsap";

export class DomControl{

    tagline :HTMLElement;
    copy :HTMLElement;
    loading :HTMLElement;
    scroll  :HTMLElement;
    
    count:number=0;
    countObj:object;
    showing:boolean=false;
    numShow:number=0;
    copyIndex:number=0;
    showingScroll:boolean=false;

    ZINDEX_SCROLL   :number=10;
    ZINDEX_TAGLINE   :number=20;
    ZINDEX_COPY     :number=30;
    ZINDEX_LOADING   :number=40;

    /*
    this.setCenter(this.tagline,999,350);
    this.setCenter(this.copy,1000,500);
    this.setCenter(this.loading,1001,16);
    */

    init(){
        
        this.initDOM();

        this.setZIndex(this.scroll,this.ZINDEX_SCROLL);

        if(this.scroll) this.scroll.style.display = "none";
        if(this.tagline) this.tagline.style.display = "none";
        if(this.copy) this.copy.style.display = "none";        

    }

    initDOM(){
        
        this.tagline = document.getElementById("mvTagline");
        this.copy = document.getElementById("mvCopy");
        this.loading = document.getElementById("mvLoading");
        this.scroll = document.getElementById("mvScroll");

    }

    setZIndex(h:HTMLElement,zIdx:number){

        if(h==null) return;
        h.style.position="absolute";
        h.style.zIndex=""+this.ZINDEX_SCROLL;

    }

    showTagline(){

        if(this.showing)return;

        this.showing=true;
        if(this.loading) this.loading.style.display = "none";
        
        if(this.numShow==0){
            this.showDOM(this.tagline);
        }else{
            this.showDOM(this.copy);
        }

        this.numShow++;

        this.resize();
   
    }

    showScroll(){

        if(!this.showingScroll){
            this.showDOM(this.scroll,0.6);
        }
        this.showingScroll=true;
    }

    hideScroll(){
        this.scroll.style.display="none";
    }


    showDOM(tgt:HTMLElement,duration:number=0.3){
        tgt.style.display = "block";
        let count=0;
        this.resize();

        gsap.to(this,{
            duration:duration,
            onUpdate:()=>{
                count++;
                if(count%2==0) tgt.style.opacity="100%"
                else tgt.style.opacity="5%"
            },
            onComplete:()=>{
                tgt.style.opacity="100%"
                this.resize();
            }
        });
    }


    hideTagline(delay:number){
        this.showing=false;
        if(this.tagline)this.tagline.style.display = "none";
        if(this.copy)this.copy.style.display ="none";
    }

    setCopy(){
        let list = [
            "",
            "",
            ""
        ];
        this.copy.innerHTML=list[this.copyIndex%list.length];
        this.copyIndex++;
        this.resize();
    }

    update(){

    }

    resize(){

        this.initDOM();

        if(this.tagline) this.tagline.style.width="350px";
        if(this.copy) this.copy.style.width="500px";
        if(this.loading) this.loading.style.width="16px";
        
        this.setCenter(this.tagline,this.ZINDEX_TAGLINE,350);
        this.setCenter(this.copy,this.ZINDEX_COPY,500);
        this.setCenter(this.loading,this.ZINDEX_LOADING,16);
        this.setBottom(this.scroll,this.ZINDEX_SCROLL,115);
        

    }

    setCenter(dom:HTMLElement,zIndex:number,width:number){
        
        if(dom==null)return;
        
        dom.style.position = "absolute";
        dom.style.zIndex= ""+zIndex;
        let domW = width;
        let domH = dom.clientHeight;
        dom.style.left = (window.innerWidth/2-domW/2)+"px";
        dom.style.top = (window.innerHeight/2-domH/2)+"px";

    }

    setBottom(dom:HTMLElement,zIndex:number,width:number){
        
        if(dom==null)return;

        dom.style.position = "absolute";
        dom.style.zIndex= ""+zIndex;
        let domW = width;
        let domH = dom.clientHeight;
        dom.style.left = (window.innerWidth/2-domW/2)+"px";
        dom.style.top = (window.innerHeight-domH)+"px";

    }


}
